"use strict";

exports.__esModule = true;
exports.getMetricDefinition = getMetricDefinition;
exports.getUnitForMetric = getUnitForMetric;
exports.metricDefinitions = void 0;
var _constants = require("../../Components/constants");
var TOTAL_PART_COUNT = "total_part_count";
var STAFFED_UTILIZATION = "staffed_utilization";
var NET_UTILIZATION = "net_utilization";
var UTILIZATION = "utilization";
var CYCLE_TIME = "cycle_time";
var AVAILABILITY = "availability";
var QUALITY = "quality";
var PERFORMANCE = "performance";
var OEE = "oee";
var MTBF = "mtbf";
var FAULT_COUNT = "fault_count";
var WARNING_COUNT = "warning_count";
var CONDITION_COUNT = "condition_count";
var DURATION_SUM = "duration_sum";
var PRODUCING_DURATION = "producing_duration";
var NON_PRODUCING_DURATION = "non_producing_duration";
var PDT_DURATION = "pdt_duration";
var UDT_DURATION = "udt_duration";
var STANDBY_DURATION = "standby_duration";
var SETUP_DURATION = "setup_duration";
var SHUTDOWN_DURATION = "shutdown_duration";
var DU_DURATION = "du_duration";
var PRODUCING_PERCENTAGE = "producing_percentage";
var NON_PRODUCING_PERCENTAGE = "non_producing_percentage";
var PDT_PERCENTAGE = "pdt_percentage";
var UDT_PERCENTAGE = "udt_percentage";
var STANDBY_PERCENTAGE = "standby_percentage";
var SETUP_PERCENTAGE = "setup_percentage";
var SHUTDOWN_PERCENTAGE = "shutdown_percentage";
var DU_PERCENTAGE = "du_percentage";
var GOOD_PARTS = "good_part_count";
var BAD_PARTS = "bad_part_count";
var IN_CUT_DURATION = "in_cut_duration_ada";
var CONDITION_DURATION = "condition_duration";
var ACTIVITIES = "activities";
var MTTR = "mttr";
var MTTR_PERCENTAGE = "mttr_percentage";
var MTBF_PERCENTAGE = "mtbf_percentage";
var metricDefinitions = exports.metricDefinitions = [{
  name: DURATION_SUM,
  label: "Duration",
  shortLabel: "Duration",
  description: "get the sum of duration field",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#00A796"
}, {
  name: PRODUCING_DURATION,
  label: "Producing Duration",
  shortLabel: "Producing",
  description: "get the sum of duration field when state is producing",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#6FC376"
}, {
  name: NON_PRODUCING_DURATION,
  label: "Non Producing Duration",
  shortLabel: "NonProducing",
  description: "get the sum of duration field when state is not producing",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#F6928F"
}, {
  name: PDT_DURATION,
  label: "Planned Downtime Duration",
  shortLabel: "PDT",
  description: "get the sum of duration field for planned downtime",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#FBBC6D"
}, {
  name: UDT_DURATION,
  label: "Unplanned Downtime Duration",
  shortLabel: "UDT",
  description: "get the sum of duration field for unplanned downtime",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#F6928F"
}, {
  name: STANDBY_DURATION,
  label: "Standby Duration",
  shortLabel: "Standby",
  description: "get the sum of duration field when state is standby",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#B1DAAE"
}, {
  name: SETUP_DURATION,
  label: "Setup Duration",
  shortLabel: "Setup",
  description: "get the sum of duration field when state is setup",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#CDA5CD"
}, {
  name: SHUTDOWN_DURATION,
  label: "Shutdown Duration",
  shortLabel: "Shutdown",
  description: "get the sum of duration field when state is shutdown",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#5DA5DA"
}, {
  name: DU_DURATION,
  label: "Data Unavailable Duration",
  shortLabel: "Data Unavailable",
  description: "get the sum of duration field for data unavailable",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#C1C1C1"
}, {
  name: PRODUCING_PERCENTAGE,
  label: "Producing Percentage",
  shortLabel: "Producing",
  description: "get the percentage of duration field when state is producing",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#6FC376"
}, {
  name: NON_PRODUCING_PERCENTAGE,
  label: "Non Producing Percentage",
  shortLabel: "NonProducing",
  description: "get the percentage of duration field when state is not producing",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#F6928F"
}, {
  name: PDT_PERCENTAGE,
  label: "Planned Downtime Percentage",
  shortLabel: "PDT",
  description: "get the percentage of duration field for planned downtime",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#FBBC6D"
}, {
  name: UDT_PERCENTAGE,
  label: "Unplanned Downtime Percentage",
  shortLabel: "UDT",
  description: "get the percentage of duration field for unplanned downtime",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#F6928F"
}, {
  name: STANDBY_PERCENTAGE,
  label: "Standby Percentage",
  shortLabel: "Standby",
  description: "get the percentage of duration field when state is standby",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#B1DAAE"
}, {
  name: SETUP_PERCENTAGE,
  label: "Setup Percentage",
  shortLabel: "Setup",
  description: "get the percentage of duration field when state is setup",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#CDA5CD"
}, {
  name: SHUTDOWN_PERCENTAGE,
  label: "Shutdown Percentage",
  shortLabel: "Shutdown",
  description: "get the percentage of duration field when state is shutdown",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#5DA5DA"
}, {
  name: DU_PERCENTAGE,
  label: "Data Unavailable Percentage",
  shortLabel: "Data Unavailable",
  description: "get the percentage of duration field for data unavailable",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#C1C1C1"
}, {
  name: TOTAL_PART_COUNT,
  label: "Total Part Count",
  shortLabel: "Parts",
  description: "get total part count",
  units: _constants.METRICS_COUNT,
  type: "number",
  color: "#00A796"
}, {
  name: GOOD_PARTS,
  label: "Good Part Count",
  shortLabel: "Good Parts",
  description: "get good part count",
  units: _constants.METRICS_COUNT,
  type: "number",
  color: "#6FC376"
}, {
  name: BAD_PARTS,
  label: "Bad Part Count",
  shortLabel: "Bad Parts",
  description: "get bad part count",
  units: _constants.METRICS_COUNT,
  type: "number",
  color: "#F6928F"
}, {
  name: STAFFED_UTILIZATION,
  label: "Staffed Utilization",
  shortLabel: "Staffed",
  description: "Computes fraction of producing duration for the times when `operator_id` is defined",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#6FC376"
}, {
  name: NET_UTILIZATION,
  label: "Net Utilization",
  shortLabel: "Net",
  description: "Computes fraction of producing duration for the times when `operator_id` is defined, but excluding some classifications",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#6FC376"
}, {
  name: UTILIZATION,
  label: "Utilization",
  shortLabel: "Utilization",
  description: "Computes ratio of producing duration to total duration except shutdown",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#6FC376"
}, {
  name: ACTIVITIES,
  label: "Activities",
  shortLabel: "Activities",
  description: "Computes ratio of activities duration to total duration except shutdown",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "duration",
  color: "#6FC376"
}, {
  name: MTTR,
  label: "MTTR",
  shortLabel: "MTTR",
  description: "Computes the fraction of total downtime and number of failures",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#6FC376"
}, {
  name: MTTR_PERCENTAGE,
  label: "MTTR Percentage",
  shortLabel: "MTTR Percentage",
  description: "Computes the fraction of MTTR and the total operational time",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#6FC376"
}, {
  name: MTBF_PERCENTAGE,
  label: "MTBF Percentage",
  shortLabel: "MTBF Percentage",
  description: "Computes the fraction of MTBF and the total operational time",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#6FC376"
}, {
  name: CYCLE_TIME,
  label: "Cycle Time",
  shortLabel: "Cycle",
  description: "Computes the fraction of total producing duration and total part count",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#6FC376"
}, {
  name: AVAILABILITY,
  label: "Availability",
  shortLabel: "Availability",
  description: "Computes the fraction of available time and the potential available time",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#6FC376"
}, {
  name: QUALITY,
  label: "Quality",
  shortLabel: "Quality",
  description: "Computes the fraction of the number of good parts produced and the total parts produced",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#6FC376"
}, {
  name: PERFORMANCE,
  label: "Performance",
  shortLabel: "Performance",
  description: "Computes the fraction of the ideal cycle time and the actual cycle time",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#6FC376"
}, {
  name: OEE,
  label: "OEE",
  shortLabel: "OEE",
  description: "Computes oee metric",
  units: _constants.METRICS_FRACTIONAL_PERCENT,
  type: "fractionalPercent",
  color: "#6FC376"
}, {
  name: MTBF,
  label: "MTBF",
  shortLabel: "MTBF",
  description: "Computes mtbf metric",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#6FC376"
}, {
  name: FAULT_COUNT,
  label: "Fault Count",
  shortLabel: "Faults",
  description: "Computes the number of faults",
  units: _constants.METRICS_COUNT,
  type: "number",
  color: "#F6928F"
}, {
  name: WARNING_COUNT,
  label: "Warning Count",
  shortLabel: "Warnings",
  description: "Computes the number of warnings",
  units: _constants.METRICS_COUNT,
  type: "number",
  color: "#F6928F"
}, {
  name: CONDITION_COUNT,
  label: "Condition Count",
  shortLabel: "Conditions",
  description: "Computes the number of conditions",
  units: _constants.METRICS_COUNT,
  type: "number",
  color: "#F6928F"
}, {
  name: IN_CUT_DURATION,
  label: "In Cut Duration",
  shortLabel: "In Cut",
  description: "Computes in-cut duration",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#6FC376"
}, {
  name: CONDITION_DURATION,
  label: "Condition Duration",
  shortLabel: "Condition Duration",
  description: "Computes condition duration",
  units: _constants.METRICS_MILLISECOND,
  type: "duration",
  color: "#F6928F"
}];

/**
 * Get the definition for the metric with the given name.
 */
function getMetricDefinition(name) {
  for (var i = 0; i < metricDefinitions.length; i++) {
    var definition = metricDefinitions[i];
    if (definition.name === name) {
      return definition;
    }
  }
  throw new Error("Unknown metric: " + name);
}
function getUnitForMetric(metricName) {
  var metricDef = metricDefinitions.filter(function (x) {
    return x.name === metricName;
  });
  if (metricDef.length === 0) {
    throw new Error("Unknown metric: " + metricName);
  }
  return metricDef[0].units;
}